import AttendApplicationListV3 from './AttendApplicationListV3';

export default AttendApplicationListV3;
